import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import type { VoiceProfile, VoicePatch, VoiceKey } from "../../../shared/types";

export function useVoiceProfile(brandId: string | undefined, voiceKey: VoiceKey) {
  return useQuery({
    queryKey: ["voice-profile", brandId, voiceKey],
    queryFn: () =>
      api.get<{ data: VoiceProfile }>(
        `/api/brands/${encodeURIComponent(brandId!)}/voice/${encodeURIComponent(voiceKey)}`,
      ),
    enabled: !!brandId,
  });
}

export function useVoiceHistory(brandId: string | undefined, voiceKey: VoiceKey) {
  return useQuery({
    queryKey: ["voice-history", brandId, voiceKey],
    queryFn: () =>
      api.get<{ data: VoicePatch[] }>(
        `/api/brands/${encodeURIComponent(brandId!)}/voice/${encodeURIComponent(voiceKey)}/history`,
      ),
    enabled: !!brandId,
  });
}
